import router from "@/router";
import Login from "@/services/Login";
const authenticate=()=>{
     router.beforeEach(async(to,from, next)=>{
      if(to.matched.some(record=> record.meta.requiresAuth)){
     const token= localStorage.getItem("access_token");
     if(token==null){
        next({path:"/login"});
     }else{
        const user=  new Login();
        const isAuthenticated= await user.auth();
        if(isAuthenticated.status){
            next();
        }else{
            next({path:"/login"});
        }
     }
    }else{
        next();
    }
    });
}

export default authenticate;
